import { render, staticRenderFns } from "./PanelCodigos.vue?vue&type=template&id=4d176a7a&scoped=true&"
import script from "./PanelCodigos.vue?vue&type=script&lang=js&"
export * from "./PanelCodigos.vue?vue&type=script&lang=js&"
import style0 from "./PanelCodigos.vue?vue&type=style&index=0&id=4d176a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d176a7a",
  null
  
)

export default component.exports